export function ItalicIcon(): JSX.Element {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6329 0.0693359H3.90046C3.80133 0.0693359 3.72023 0.147098 3.72023 0.242142V1.62459C3.72023 1.71963 3.80133 1.79739 3.90046 1.79739H7.98266L4.46818 13.5482H0.814019C0.714892 13.5482 0.633789 13.6259 0.633789 13.721V15.1034C0.633789 15.1985 0.714892 15.2762 0.814019 15.2762H10.5464C10.6456 15.2762 10.7267 15.1985 10.7267 15.1034V13.721C10.7267 13.6259 10.6456 13.5482 10.5464 13.5482H6.34257L9.85705 1.79739H13.6329C13.732 1.79739 13.8131 1.71963 13.8131 1.62459V0.242142C13.8131 0.147098 13.732 0.0693359 13.6329 0.0693359Z"
        fill="currentColor"
      />
    </svg>
  );
}
